import { useState, useContext, useEffect } from 'react'
import { StoreContext } from '../store/StoreProvider'
import { notificacionApi as api } from '../../api/notificacionApi'
import { types } from '@customstore/storeReducer'
export const useNotificacion = (initialState) => {
  const [store, dispatch] = useContext(StoreContext)
  const { usuarioActivo, notificacionesNuevas } = store 
  const [notificacionesBd, setNotificacionesBd] = useState([])
  const [leidas, setLeidas] = useState([])
  const [noLeidas, setNoLeidas] = useState([])  
  const [listenBD, setlistenBD] = useState(false)  
  const [loading, setLoading] = useState(false)
    
  function actualizarRedux() {
    const leidasTmp   = notificacionesBd.filter(i => { if (i.status == true)  return i })
    const noLeidasTmp = notificacionesBd.filter(i => { if (i.status == false)   return i })
    setLeidas(leidasTmp)
    setNoLeidas(noLeidasTmp)
    dispatch({ type: types.setNotificacionesAnteriores, payload: leidasTmp })
    dispatch({ type: types.setNotificacionesNuevas,     payload: noLeidasTmp })
    dispatch({ type: types.setNumNotificaciones,        payload: noLeidasTmp.length })
    setlistenBD(true)
  } 

  function actualizarNotificaciones(data) {
    setNotificacionesBd(null)
    setNotificacionesBd([...data])
    dispatch({ type: types.setNotificaciones, payload: [...data] })
    setlistenBD(true)
  }

  const onLoadSuccess = (res) => {
    /* manejador del evento load - Si la promesa de load se cumple*/
    //  setLoading(false)
    const loadSucceded = JSON.parse(JSON.stringify(res)).status === 200 
      if (loadSucceded) {
        actualizarNotificaciones(res.data.data.reverse())
      } else if (!loadSucceded) {
      }
  }

  const onLoadError = (error) => {
    setLoading(false)
    console.log(error)
  }

  const load = async (filtros) => {
    await api.load(filtros)
      .then(onLoadSuccess)
      .catch(onLoadError)
  }

  const addNotification = (notificaciones, nuevaNotificacion) => {
    const tmp = [nuevaNotificacion, ...notificacionesBd]
    actualizarNotificaciones([...tmp])
    // actualizarRedux()
    // setNoLeidas(tmp)
    // dispatch({ type: types.setNotificacionesNuevas, payload: tmp })
    // dispatch({ type: types.setNumNotificaciones,    payload: tmp.length })
  }

  const deleteNotificacion = (data) => {
    const tmp = notificacionesBd
    tmp.forEach(i => { 
      if (i._id == data._id) {
        console.log(i)
        i.status = true
      }
    })
    actualizarNotificaciones(tmp)
    actualizarRedux()
  }

  const administrar = async (formData, callback) => {
    setLoading(true)
    formData = { ...formData, idUsuario: usuarioActivo._id }
    await api
      .admin(formData)
      .then((res) => {
        setLoading(false)
        if (JSON.parse(JSON.stringify(res)).status == 200) {
          callback(res)
        } else {
          console.log(res.data.error)
        }
      })
      .catch((error) => {
        setLoading(false)
        console.log(error)
      })
  }

  useEffect(() => {
    if (listenBD) {
      actualizarRedux()
      setlistenBD(false)
    }
  }, [notificacionesBd])  

  return {
    load,
    addNotification,
    administrar,
    loading,
    deleteNotificacion,
    // defaultFiltros,
    // loadNuevas,
    // loadAnteriores,
    // modifyNotification
    noLeidas
  }
}
